<cm-overlay
  [width]="1150"
  [height]="640"
  header="{{ 'MENU_MESSAGE_HISTORY_TITLE' | translate }}"
  [justifyTop]="true"
>
  <app-message-set-history-viewer></app-message-set-history-viewer>
</cm-overlay>
